<script setup>
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { route } from '#/vendor/tightenco/ziggy'
  import { useUser } from '@/hooks'
  import { usePage } from '@inertiajs/vue3'

  const { t } = useI18n()
  const { showBillingBanner } = useUser()

  // computed property of the current route of inertia
  const isProfileRoute = computed(() => {
    return usePage().component === 'Profile'
  })
</script>

<template>
  <div v-if="showBillingBanner && !isProfileRoute" class="px-3">
    <div class="mx-3 mt-3">
      <v-banner
        class="rounded"
        bg-color="error"
        color="white"
        icon="mdi-alert-outline"
        :text="t('messages.billing-banner')"
        :lines="$vuetify.display.smAndDown ? 'two' : 'one'"
        elevation="2"
      >
        <template v-slot:actions>
          <ue-link :href="route('admin.profile')" :only="['mainConfiguration']">
            <v-btn color="white" variant="flat" class="text-error">
              {{ t('Update') }}
            </v-btn>
          </ue-link>
        </template>
      </v-banner>
    </div>
  </div>
  <v-alert class="d-sm-none mx-3 mt-3"
      closable
      :text="t('For a better user experience, please switch to desktop.')"
  ></v-alert>
</template>

